import { Injectable } from "@angular/core";
import { environment } from "projects/assist/src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class BeaconService {
  private beaconLoaded = false;
  private savedUser: any = {};
  constructor() {}

  init(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.beaconLoaded || !environment.beaconEnabled) {
        resolve();
        return;
      }

      const checkInterval = setInterval(() => {
        if (typeof window.Beacon === "function") {
          clearInterval(checkInterval);
          window.Beacon("init", environment.beaconId);
          this.beaconLoaded = true;
          resolve();
        }
      }, 100);

      setTimeout(() => {
        if (!this.beaconLoaded) {
          clearInterval(checkInterval);
          reject("Beacon failed to initialize");
        }
      }, 10000);
    });
  }

  suggest(docs: string[]): void {
    if (this.beaconLoaded) window.Beacon("suggest", docs);
  }

  identify(user: {
    name?: string;
    email?: string;
    company?: string;
    [key: string]: string | number | undefined | null;
  }): void {
    if (this.beaconLoaded) {
      let combinedUser = { ...this.savedUser, ...user };
      window.Beacon("identify", combinedUser);
      this.savedUser = combinedUser;
    }
  }

  close(): void {
    if (this.beaconLoaded) window.Beacon("close");
  }

  sessionData(data: any): void {
    if (this.beaconLoaded) window.Beacon("session-data", data);
  }

  searchDocs(query: string): void {
    if (this.beaconLoaded) window.Beacon("search", query);
  }
}
